import { render, staticRenderFns } from "./grid-video.vue?vue&type=template&id=5a049be4"
import script from "./grid-video.vue?vue&type=script&lang=js"
export * from "./grid-video.vue?vue&type=script&lang=js"
import style0 from "./grid-video.vue?vue&type=style&index=0&id=5a049be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports